import { Button, Typography, withTheme } from 'material-ui';
import React, { Component } from 'react';
import FileContent from '../resource_content/FileContent';

class TermContent extends Component {

  render() {
    var info = this.props.resources[this.props.resourceID];
    var description = info.description;
    var docID = info.resourceID;
    var docInfo = this.props.resources[docID]
    var url = info.url;
    if(!description && !docID && url) {
      window.location.replace(url);
    }
    return (
      <React.Fragment>
        <Typography variant='display2'>{info.name}</Typography>
        {docInfo?
          <FileContent url={docInfo.url} resources={this.props.resources}/>
        :
          description?
            <Typography variant='body1'>{description}</Typography>
          :
            null
        }
        {
          url?
            <Button variant='raised' color='primary' href={url}>READ MORE</Button>
          :
            null
        }
      </React.Fragment>
    );
  }
}

export default withTheme()(TermContent);


// WEBPACK FOOTER //
// ./src/resource_content/TermContent.js